import { CalendarRange, Id } from "PFTypes";

import { PER_PAGE, RequestData } from "./get_request_data";

export const getProfilesLinkedToEngagementRequest = (id: Id, dateRange: CalendarRange): RequestData => ({
  url: "booking_module/activity_profiles",
  params: { perPage: PER_PAGE, activityId: id, dateRange },
  childrenType: "profile"
});
